import { useMemo } from 'react';
import { useSmartformContext } from '../../forms';
export { UserEvents } from './Events/UserEvents';

const noop = () => {};

export function useUserEvent() {
  const { onTrackUserEvent = noop } = useSmartformContext();

  return useMemo(
    () => ({
      track: onTrackUserEvent
    }),
    [onTrackUserEvent]
  );
}
